import {
  parseExtractedQuantity,
  toExcelRowNumber,
} from '../../lib/stockImportsFormat'
import { formatMissingSkuReason } from '../../lib/stockImportsMessages'
import cn from '../../StockImportsTab/StockImportsTab.module.scss'
import type { StockImportsTableColumn } from '../../StockImportsVirtualTable/StockImportsVirtualTable'
import tableCn from '../../StockImportsVirtualTable/StockImportsVirtualTable.module.scss'
import type { PreviewRowDto } from '../../types/stockImports.types'

const previewStatusLabelMap: Record<string, string> = {
  OK: 'Корректно',
  SUCCESS: 'Успешно',
  ERROR: 'Ошибка',
}

export const isZeroQuantityRow = (row: PreviewRowDto) =>
  row.status !== 'ERROR' && parseExtractedQuantity(row.extractedQuantity) === 0

export const previewColumns: StockImportsTableColumn<PreviewRowDto>[] = [
  {
    id: 'sheetName',
    header: 'Лист',
    width: 'minmax(90px, 0.7fr)',
    cell: ({ row }) => (
      <span className={tableCn.cellEllipsis} title={row.original.sheetName}>
        {row.original.sheetName}
      </span>
    ),
  },
  {
    id: 'rowIndex',
    header: 'Строка',
    width: 'minmax(64px, 0.55fr)',
    cell: ({ row }) => toExcelRowNumber(row.original.rowIndex),
  },
  {
    header: 'Артикул (производителя)',
    accessorKey: 'extractedArticle',
    width: 'minmax(130px, 1.1fr)',
  },
  {
    id: 'extractedArticleInch',
    header: 'Артикул (поставщика)',
    width: 'minmax(130px, 1.1fr)',
    cell: ({ row }) => row.original.extractedArticleInch ?? '—',
  },
  {
    id: 'extractedBarcode',
    header: 'Штрихкод',
    width: 'minmax(110px, 0.9fr)',
    cell: ({ row }) => row.original.extractedBarcode ?? '—',
  },
  {
    id: 'extractedBrand',
    header: 'Бренд',
    width: 'minmax(110px, 0.9fr)',
    cell: ({ row }) => (
      <span className={cn.previewBrand}>
        {row.original.extractedBrand}
        {row.original.brandDetectedInDescription && (
          <span className={cn.previewBrandSource}>из наименования</span>
        )}
      </span>
    ),
  },
  {
    header: 'Наименование',
    accessorKey: 'extractedDescription',
    width: 'minmax(240px, 2fr)',
  },
  {
    id: 'extractedQuantity',
    header: 'Остаток',
    width: 'minmax(74px, 0.65fr)',
    cell: ({ row }) => (
      <span
        className={
          isZeroQuantityRow(row.original) ? cn.previewZeroQuantity : undefined
        }
      >
        {row.original.extractedQuantity ?? '—'}
      </span>
    ),
  },
  {
    id: 'status',
    header: 'Статус',
    width: 'minmax(92px, 0.8fr)',
    cell: ({ row }) => (
      <span
        className={
          row.original.status === 'ERROR' ? cn.previewErrorStatus : undefined
        }
      >
        {previewStatusLabelMap[row.original.status] ?? row.original.status}
      </span>
    ),
  },
  {
    id: 'reason',
    header: 'Причина',
    width: 'minmax(190px, 1.5fr)',
    cell: ({ row }) => {
      const reason = formatMissingSkuReason(
        row.original.reason,
        row.original.searchedBy
      )
      return reason
    },
  },
]
